import StorageKeys from "../../const/StorageKeys";
import CacheStorage from "../../service/storage/CacheStorage";
import ApiUrls from "../../service/api/ApiUrls";
import ApiService from "../../service/api/ApiService";
import { navigate } from "../../service/navigation/Navigation";
import UtilityHelper from "../../service/utilities/UtilityHelper";
import ShowToast from "../../widget/common/ui/Toast";
import {
  SearchBranchList,
  SearchBranchListModel,
} from "../../model/search/SearchBranchListModel";
import {
  ProfileList,
  SearchProfileListModel,
} from "../../model/search/SearchProfileListModel";
import SessionStorage from "../../service/storage/SessionStorage";

const SearchProvider = new (class SearchProvider {
  navigate = (url: string) => {
    if (UtilityHelper.isNotEmpty(url)) {
      navigate(url);
    }
  };

  getProfileListAPI = async (params: {
    branchId: string;
    keyword: string;
    signal: AbortSignal;
  }): Promise<Array<ProfileList> | null> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}search/search_team_profile`;
    const body: any = {
      account_id: accountId,
      branch_id: params.branchId,
      keyword: params.keyword,
      page: "1",
    };
    const response: any = await ApiService.postApi(
      url,
      body,
      false,
      false,
      params.signal
    );
    if (response != null) {
      if (response["success"] === "1") {
        const searchProfileListModel: SearchProfileListModel = response;
        const searchProfileList: Array<ProfileList> =
          searchProfileListModel?.result?.search_team_profile_list
            ?.profile_list!;

        return searchProfileList ?? null;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };

  getBranchListAPI = async (params: {
    country_id: string;
    state_id: string;
    city_id: string;
    area_id: string;
    latitude: string;
    longitude: string;
  }): Promise<Array<SearchBranchList> | null> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}search/get_branch_list`;
    let body: any = {
      account_id: accountId,
      country_id: params.country_id,
      state_id: params.state_id,
      city_id: params.city_id,
      area_id: params.area_id,
      latitude: params.latitude,
      longitude: params.longitude,
    };

    const divisionId: string =
      SessionStorage.getValue(StorageKeys.division_id) ||
      CacheStorage.getValue(StorageKeys.division_id) ||
      "";

    if (UtilityHelper.isNotEmpty(divisionId)) {
      body = { ...body, division_id: divisionId };
    }

    console.log(body);
    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const searchBranchListModel: SearchBranchListModel = response;
        const searchBranchList: Array<SearchBranchList> =
          searchBranchListModel?.result?.search_branch_list!;

        return searchBranchList ?? null;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default SearchProvider;
